import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { OtpRequestType } from 'src/app/models/otp-option';
import { AddBankTemplates, BankDetails } from 'src/app/models/bank-details';
import { ExternalSystemsService } from 'src/app/api/external-systems.service';
import { UserBanksService } from 'src/app/api/user-banks.service';
import { ExternalServicesErrors } from 'src/app/models/external-systems';

@Component({
  selector: 'add-bank',
  templateUrl: './add-bank.component.html',
  styleUrls: ['./add-bank.component.scss']
})
export class AddBankComponent implements OnInit {
  @Output() confirm = new EventEmitter<BankDetails>();

  AddBankTemplates = AddBankTemplates;
  OtpRequestType = OtpRequestType;

  template: AddBankTemplates = AddBankTemplates.IBAN;

  loading = false;
  error: string = null;
  data: BankDetails;

  showOtpModal = false;

  isIbanServiceAvailable = true;

  constructor(
    private externalSystemsService: ExternalSystemsService,
    private userBanksService: UserBanksService
  ) {}

  ngOnInit() {
    this.checkAvailabilityOfIbanService();
  }

  checkAvailabilityOfIbanService() {
    this.loading = true;

    this.externalSystemsService.get().subscribe(res => {
      this.loading = false;
      this.isIbanServiceAvailable = res?.ibanValidator?.enabled;
      this.setTemplate(this.isIbanServiceAvailable ? AddBankTemplates.IBAN : AddBankTemplates.MANUALLY);
    }, () => {
      this.loading = false;
      this.isIbanServiceAvailable = false;
      this.setTemplate(AddBankTemplates.MANUALLY);
    });
  }

  setTemplate(template: AddBankTemplates) {
    this.template = template;
  }

  closeOtpModal() {
    this.showOtpModal = false;
  }

  removeBank(id: number) {
    this.error = null;

    this.userBanksService.deleteUserBankDetails(id).subscribe(() => {
      this.template = AddBankTemplates.MANUALLY;
    }, error => {
      this.error = error?.errors?.[0]?.message;
    });
  }

  onBankDataSubmit(data: BankDetails) {
    this.error = null;
    this.data = data;
    this.showOtpModal = true;
  }

  onOtpSubmit(otpCode: string) {
    this.error = null;
    this.showOtpModal = false;

    this.data.isDefault = true;
    this.data.supportIban = this.template === AddBankTemplates.IBAN;
    this.userBanksService.createUserBankDetails(this.data, otpCode).subscribe(response => {
      this.data = response;
      this.template = AddBankTemplates.DETAILS;
    }, error => {
      const err = error.errors?.[0];
      if (err) {
        this.error = err.message;
        if (err.category === ExternalServicesErrors.ADD_NEW_BANK_SERVICE_ISSUE) {
          this.setTemplate(AddBankTemplates.MANUALLY);
          this.isIbanServiceAvailable = false;
        }
      }
    });
  }

  onDetailsSubmit() {
    this.error = null;
    this.confirm.emit(this.data);
  }
}
